import {Duration, DateTime} from 'luxon';

/*
  TODO: переход с секунд на миллисекунды
*/

// если разница между максимальным значением на оси времени и минимальным меньше данной константы (час + 3 минуты), то формат подписей оси времени HH:mm:ss
const limitDiffHour = (3600000 + 180000) * 1000;

// если разница между максимальным значением на оси времени и минимальным меньше данной константы (сутки + 30 минут), то формат подписей оси времени HH:mm<br />dd-MM
const limitDiffDay = (86400000 + 1800000) * 1000;

export function secToMills(date: number): number {
  return date * 1000;
}

export function millsToSec(date: number): number {
  return Math.trunc(date / 1000);
}

export function getFormattedDate(date: number, format: string) {
  return DateTime.fromMillis(date).toFormat(format);
}

export function getFormattedDateWithCondition(date: number, diff: number) {
  let displayFormat = '';
  if (diff <= limitDiffHour) {
    displayFormat = 'HH:mm:ss';
  } else if (diff <= limitDiffDay) {
    displayFormat = 'HH:mm<br />dd-MM';
  } else {
    displayFormat = 'dd-MM<br />yyyy';
  }
  return getFormattedDate(date, displayFormat);
}

function dhms(ms: number) {
  const days = Math.floor(ms / (24 * 60 * 60 * 1000));
  const daysms = ms % (24 * 60 * 60 * 1000);
  const hours = Math.floor(daysms / (60 * 60 * 1000));
  const hoursms = ms % (60 * 60 * 1000);
  const minutes = Math.floor(hoursms / (60 * 1000));
  const minutesms = ms % (60 * 1000);
  const sec = Math.floor(minutesms / 1000);

  return {days: days, hours: hours, minutes: minutes, sec: sec};
}

export function getDurationStr(date: number): string {
  const obj = dhms(date);

  const res = [];

  if (obj.days > 0) {
    res.push(`${obj.days} дн. `);
  }

  if (obj.hours > 0) {
    res.push(`${obj.hours} ч. `);
  }

  if (obj.minutes > 0) {
    res.push(`${obj.minutes} мин. `);
  }

  if (obj.sec > 0) {
    res.push(`${obj.sec} с. `);
  }

  if (!res.length) return '0 с.';

  return res.join(' ');
}

export function getDurationWithFormat(start: number, end: number) {
  const dur = Duration.fromMillis(end - start);
  const days = dur.as('days');
  let formatStart = 'HH:mm';
  let formatEnd = 'HH:mm';
  if (days >= 1) {
    formatStart = 'dd';
    formatEnd = 'dd.MM.yyyy';
  }
  return `${DateTime.fromMillis(start).toFormat(formatStart)}-${DateTime.fromMillis(end).toFormat(
    formatEnd,
  )}`;
}

export function getNow() {
  return Date.now();
}

export function getNowInSec() {
  return Math.floor(Date.now() / 1000);
}

// TODO не передавать 'plus' или 'minus'
export function getNowWithInterval(interval: DurationObject, action: IntervalAction): number {
  const now = DateTime.local();
  if (action === 'plus') {
    return now.plus(interval).valueOf();
  } else if (action === 'minus') {
    return now.minus(interval).valueOf();
  }
  return 0;
}

// TODO вынести отдельно?
type IntervalAction = 'minus' | 'plus';
interface DurationObject {
  minutes?: number;
  hours?: number;
  days?: number;
  years?: number;
}

export const getDateWithTime = (timestamp: number) => {
  const date = new Date(timestamp);

  const day = date
    .getDate()
    .toString()
    .padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date
    .getHours()
    .toString()
    .padStart(2, '0');
  const minutes = date
    .getMinutes()
    .toString()
    .padStart(2, '0');
  const seconds = date
    .getSeconds()
    .toString()
    .padStart(2, '0');

  return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
};
